import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { MaterialIcon } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import Circular from 'components/ProgressBar/Circular';
import {
  UploadFileWrapper,
  FileNameWrapper,
  FileIcon,
  ProgressIndicator,
  WarningIcon,
  WarningWrapper,
  UploadFileCancelButton,
  ErrorWarningIcon,
} from './styles';
import messages from './messages';
import { UPLOAD_FAILED, UPLOAD_COMPLETED } from './constants';

const UploadFileModal = ({
  theme,
  percentage,
  file,
  uploadState,
  handleTryAgain,
  handleClose,
}) => {
  const showUploadStatusMessage = () => {
    if (uploadState === UPLOAD_COMPLETED) {
      return (
        <>
          <WarningWrapper>
            <WarningIcon uploadState={UPLOAD_COMPLETED}>
              <MaterialIcon id="check_circle_rounded" />
            </WarningIcon>
            {intl.formatMessage(messages.uploadCompleted)}
          </WarningWrapper>
        </>
      );
    }
    if (uploadState === UPLOAD_FAILED) {
      return (
        <>
          <WarningWrapper uploadState={uploadState}>
            <ErrorWarningIcon>
              <MaterialIcon id="error" />
            </ErrorWarningIcon>
            {intl.formatMessage(messages.importFailed)}
          </WarningWrapper>
          <UploadFileCancelButton
            primary
            type="submit"
            onClick={handleTryAgain}
          >
            {intl.formatMessage(messages.tryAgain)}
          </UploadFileCancelButton>
        </>
      );
    }
    return (
      <>
        <WarningWrapper>
          <WarningIcon>
            <MaterialIcon id="warning_triangle" />
          </WarningIcon>
          {intl.formatMessage(messages.warning)}
        </WarningWrapper>
        <UploadFileCancelButton primary type="submit" onClick={handleClose}>
          {intl.formatMessage(messages.cancel)}
        </UploadFileCancelButton>
      </>
    );
  };

  return (
    <>
      <UploadFileWrapper>
        <FileNameWrapper>
          <span><FileIcon icon="duotoneFile"></FileIcon></span>
          {file?.name}
        </FileNameWrapper>
        <ProgressIndicator>
          <Circular
            percentage={percentage}
            radius={78}
            trackWidth={12}
            trackColor={theme['color.greyDark']}
            progressFillColor={theme['color.greenLight']}
          />
        </ProgressIndicator>
        {showUploadStatusMessage()}
      </UploadFileWrapper>
    </>
  );
};

UploadFileModal.propTypes = {
  percentage: PropTypes.number,
  theme: PropTypes.object,
  file: PropTypes.object,
  uploadState: PropTypes.number,
  handleTryAgain: PropTypes.func,
  handleClose: PropTypes.func,
};

export default withTheme(UploadFileModal);
